// extracted by mini-css-extract-plugin
export default {"trigger":"ExploreMenu_trigger__xfm4W"};